import Actions, { type AlertActionsProps } from "./Actions";
import BadgeLayout, { type AlertBadgeLayoutProps } from "./BadgeLayout";
import Close, { type AlertCloseProps } from "./Close";
import IconLayout, { type AlertIconLayoutProps } from "./IconLayout";
import Root, { type AlertRootProps } from "./Root";

export { default as BasicAlert, type BasicAlertProps } from "./BasicAlert";

export const Alert = {
  Root,
  BadgeLayout,
  IconLayout,
  Close,
  Actions,
};

export type { AlertActionsProps, AlertBadgeLayoutProps, AlertCloseProps, AlertIconLayoutProps, AlertRootProps };
